import React from 'react';
import {Icon} from 'antd';

const CopywritingTips = () => {
    return (
        <div style={{fontSize:12,color:'#F78900',lineHeight:'20px'}}><Icon style={{marginRight:5}} type="info-circle" theme="filled" />For SDK V5.8.6 and later, the configuration supports local setup within the SDK with higher priority than the console.</div>
    );
};

export default CopywritingTips;



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/CopywritingTips.js